module.exports = __webpack_public_path__ + "static/media/bell pepper.17b3d1ef.png";